import React from 'react';
import Modal from './ui/Modal';

interface RegistrationSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  userDetails?: {
    username: string;
    firstName: string;
  };
}

export const RegistrationSuccessModal: React.FC<RegistrationSuccessModalProps> = ({
  isOpen,
  onClose,
  userDetails
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm" showClose={false}>
      <div className="text-center">
        <div className="w-20 h-20 bg-gradient-to-r from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h2 className="text-2xl font-bold text-white mb-2">
          Garage ready
        </h2>

        {userDetails && (
          <p className="text-gray-300 mb-6">
            Hi <span className="text-orange-400 font-medium">{userDetails.firstName}</span>.
            You’re signed in as <span className="text-blue-400 font-medium">@{userDetails.username}</span>.
            Next: add your first build.
          </p>
        )}

        <button
          onClick={onClose}
          className="w-full btn-primary font-semibold py-3 px-6"
        >
          Add a Build
        </button>
      </div>
    </Modal>
  );
};
